var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPumpWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2.9C5 2.40294 5.40294 2 5.9 2H13.1C13.5971 2 14 2.40294 14 2.9C14 3.39706 13.5971 3.8 13.1 3.8H10.4125L10.4125 3.80492V5.6H11.1C12.2046 5.6 13.1 6.49543 13.1 7.6V14.1065C14.4463 13.7093 15.4288 12.4638 15.4288 10.9889V8.2001H15.35C14.7977 8.2001 14.35 7.75238 14.35 7.2001V5.6001C14.35 5.04781 14.7977 4.6001 15.35 4.6001H16.95C17.4685 4.6001 17.8948 4.99471 17.945 5.5H18.4C18.8971 5.5 19.3 5.90294 19.3 6.4C19.3 6.89706 18.8971 7.3 18.4 7.3H17.945C17.8949 7.80538 17.4685 8.2001 16.95 8.2001H16.9288V10.9889C16.9288 13.297 15.2825 15.2207 13.1 15.6496V16.2C13.1 17.3046 12.2046 18.2 11.1 18.2H7.9C6.79543 18.2 5.9 17.3046 5.9 16.2V7.6C5.9 6.49543 6.79543 5.6 7.9 5.6H8.60747V3.80492L8.60748 3.8H5.9C5.40294 3.8 5 3.39706 5 2.9ZM9.51001 7.41516C8.51313 7.41516 7.705 8.22329 7.705 9.22018C7.705 10.2171 8.51313 11.0252 9.51001 11.0252C10.5069 11.0252 11.315 10.2171 11.315 9.22018C11.315 8.22329 10.5069 7.41516 9.51001 7.41516Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPumpWhite);
export default __webpack_public_path__ + "static/media/pump-white.555d21be388a59b90be0da965df146e2.svg";
export { ForwardRef as ReactComponent };